import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import parameterTypeParser from "../../../libs/parameterTypeParser";

class StationObservationTime extends React.Component {
  render() {
    // console.log(this.props.data);
    // console.log(new Date(this.props.data[0][0]));
    // let groupedData = _.groupBy(this.props.data, item => moment.utc(item[0]).format('YYYY-MM-DD'));
    return (
      <table>
        <thead>
        <tr>
          <th>Date Time</th>
          <th>Value</th>
        </tr>
        </thead>
        <tbody>
        {/*{Object.keys(groupedData).map(date => ([groupedData[date].map((item, i) => (<tr>*/}
        {/*<td style={{fontWeight: i === 0 ? 'bold': 'normal'}}>{moment.utc(item[0]).format('YYYY-MM-DD HH:mm:ss')}</td>*/}
        {/*<td>{item[1] ? parameterTypeParser(item[1], 'time') : ''}</td>*/}
        {/*</tr>)), <br/>]))}</tbody>*/}
        {this.props.data.map(item => (<tr>
          <td>{moment.utc(item[0]).format('YYYY-MM-DD HH:mm:ss')}</td>
          <td>{item[1] ? parameterTypeParser(item[1], this.props.property) : ''}</td>
        </tr>))}
        </tbody>
      </table>
    );
  }
}

export default StationObservationTime;


// WEBPACK FOOTER //
// ./src/components/Station/Observation/StationObservationTime.js